var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1763 8C10.1763 8.41421 9.84048 8.75 9.42627 8.75L2.66627 8.75C2.25206 8.75 1.91627 8.41421 1.91627 8C1.91627 7.58579 2.25206 7.25 2.66627 7.25L9.42627 7.25C9.84048 7.25 10.1763 7.58579 10.1763 8Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5425 12.5833C11.93 12.5833 12.2305 12.2747 12.2305 11.9099L12.2305 4.08992C12.2305 3.72383 11.9275 3.41463 11.5396 3.41658L8.76056 3.42924C8.34635 3.43113 8.00903 3.09688 8.00714 2.68267C8.00526 2.26846 8.33951 1.93115 8.75372 1.92926L11.532 1.91659C11.5322 1.91659 11.5319 1.91659 11.532 1.91659C12.7373 1.91073 13.7305 2.87879 13.7305 4.08992L13.7305 11.9099C13.7305 13.1172 12.7443 14.0833 11.5425 14.0833L8.66647 14.0833C8.25225 14.0833 7.91647 13.7475 7.91647 13.3333C7.91647 12.919 8.25226 12.5833 8.66647 12.5833L11.5425 12.5833Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86383 11.1968C5.57093 11.4897 5.09606 11.4897 4.80317 11.1968L2.1365 8.53017C1.84361 8.23727 1.84361 7.7624 2.1365 7.46951L4.80317 4.80284C5.09606 4.50995 5.57093 4.50995 5.86383 4.80284C6.15672 5.09573 6.15672 5.57061 5.86383 5.8635L3.72749 7.99984L5.86383 10.1362C6.15672 10.4291 6.15672 10.9039 5.86383 11.1968Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.b7153a47232613146f953f9a17dc889b.svg";
export { ForwardRef as ReactComponent };